import * as React from "react";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export default function CloseButton(props: SvgIconProps) {
	return (
		<SvgIcon
			{...props}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle cx="12" cy="12" r="12" fill="#E3E3EB" />
			<path
				d="M17 8.24532L15.7547 7L12.0011 10.7558L8.24532 7L7 8.24532L10.7558 12.0011L7 15.7547L8.24532 17L12.0011 13.2442L15.7547 17L17 15.7547L13.2442 12.0011L17 8.24532Z"
				fill="#7F7F87"
			/>
		</SvgIcon>
	);
}
